import React from 'react';
import { Button, Drawer } from '../../../../../../../ui';

interface ISelectQuestions {
  isOpen: boolean;
  onCloseDrawer: () => void; // Fixed function type
}

export const SelectQuestions = ({
  isOpen,
  onCloseDrawer,
}: ISelectQuestions) => {
  return (
    <Drawer
        isOpen={isOpen}
        onClose={onCloseDrawer}
        footerContent={
          <div className='flex justify-end gap-5 w-full'>
            <Button label='Cancel' onClick={onCloseDrawer} variant='secondary' />{ ' ' }
            <Button label='Create' onClick={() => {}} variant='primary' />
          </div>
        }
        title='Select Question'
        width='w-full md:w-1/3'
    >
      <></>
    </Drawer>
  );
};
